export const bufferToImageData = (
  buffer: ArrayBuffer,
  height: number,
  width: number,
) => new ImageData(new Uint8ClampedArray(buffer), width, height);

const CANVAS_IMAGE_DRAW_VERSION_KEY = '__frameImageDrawVersion';

type CanvasWithDrawVersion = (HTMLCanvasElement | OffscreenCanvas) & {
  [CANVAS_IMAGE_DRAW_VERSION_KEY]?: number;
};

const increaseCanvasImageDrawVersion = (
  canvas: HTMLCanvasElement | OffscreenCanvas,
) => {
  const targetCanvas = canvas as CanvasWithDrawVersion;

  targetCanvas[CANVAS_IMAGE_DRAW_VERSION_KEY] =
    (targetCanvas[CANVAS_IMAGE_DRAW_VERSION_KEY] ?? 0) + 1;
};

export const bufferToBitmap = (
  buffer: ArrayBuffer,
  option?: { height: number; width: number },
) =>
  !option
    ? createImageBitmap(new Blob([buffer], { type: 'image/*' }))
    : createImageBitmap(bufferToImageData(buffer, option.height, option.width));

const readyCanvasBeforeDraw = (
  canvas: HTMLCanvasElement | OffscreenCanvas,
  width: number,
  height: number,
) => {
  const context = canvas?.getContext('2d') as
    | OffscreenCanvasRenderingContext2D
    | CanvasRenderingContext2D;

  if (!context) return;

  canvas.width = width;
  canvas.height = height;

  if (context instanceof CanvasRenderingContext2D)
    context.clearRect(0, 0, canvas.width, canvas.height);

  return context;
};

export const drawImageOnCanvasFromBitmap = (
  canvas: HTMLCanvasElement | OffscreenCanvas,
  bitmap: ImageBitmap,
) => {
  const context = readyCanvasBeforeDraw(canvas, bitmap.width, bitmap.height);

  if (!context) return;

  try {
    context.drawImage(bitmap, 0, 0, bitmap.width, bitmap.height);
    increaseCanvasImageDrawVersion(canvas);
  } catch (error) {
    console.group('[drawImageOnCanvasFromBitmap] error');
    console.warn(error);
    console.groupEnd();
  }
};

export const drawImageOnCanvasFromBuffer = (
  canvas: HTMLCanvasElement | OffscreenCanvas,
  {
    buffer,
    height,
    width,
  }: { buffer: ArrayBuffer; height: number; width: number },
) => {
  const context = readyCanvasBeforeDraw(canvas, width, height);

  if (!context) return;

  try {
    context.putImageData(bufferToImageData(buffer, height, width), 0, 0);
    increaseCanvasImageDrawVersion(canvas);
  } catch (error) {
    console.group('[drawImageOnCanvasFromBuffer] error');
    console.warn(error);
    console.groupEnd();
  }
};
